/* eslint-disable no-param-reassign */

import parse from 'date-fns/parse';
import formatDate from 'date-fns/format';
import isSameDay from 'date-fns/is_same_day';
import isWithinRange from 'date-fns/is_within_range';

import {getDateTime, minutesSinceMidnight} from 'utils/time';

const getDateString = date => formatDate(date, 'YYYY-MM-DD');

export const getLastCompletion = ({lastCompletion}, now) => {
    if (lastCompletion === null) return null;

    lastCompletion = parse(lastCompletion);

    if (isSameDay(now || new Date(), lastCompletion)) return lastCompletion;

    return null;
};

export const generateStartRange = (
    {id: samplingID, startTime, endTime},
    {id, questionnaire},
    now,
) => {
    const today = getDateString(now || new Date());
    const startDate = parse(`${today} ${startTime}`);
    const endDate = parse(`${today} ${endTime}`);
    const start = minutesSinceMidnight(startDate);
    const end = minutesSinceMidnight(endDate);

    return {
        id,
        samplingID,
        start,
        end,
        questionnaireID: questionnaire.id,
        completed: false,
    };
};

export const generateRanges = (
    {id: samplingID, endTime},
    startDate,
    {id, questionnaire, offset, interval, period, ...data},
    now,
) => {
    now = now || new Date();

    const today = getDateString(now);
    const endDate = getDateTime(today, endTime);

    try {
        if (!isWithinRange(now, startDate, endDate)) {
            return [];
        }
    } catch (e) {
        console.error('isWithinRange', now, today, startDate, endDate, e);
        return [];
    }

    const lastCompletion = getLastCompletion(data, now);
    const lastCompletionMinutes = lastCompletion && minutesSinceMidnight(lastCompletion);

    let startMinutes = minutesSinceMidnight(startDate) + offset;
    const endMinutes = minutesSinceMidnight(endDate);
    const ranges = [];

    while (startMinutes <= endMinutes) {
        const rangeStart = startMinutes;
        const rangeEnd = startMinutes + period;

        ranges.push({
            id,
            samplingID,
            questionnaireID: questionnaire.id,
            start: rangeStart,
            end: rangeEnd,
            completed: (
                Boolean(lastCompletion) &&
                rangeStart <= lastCompletionMinutes
                && rangeEnd >= lastCompletionMinutes
            ),
        });

        startMinutes += interval;
    }

    return ranges;
};

export const getCurrentRanges = ({samplings, ranges}, now) => {
    now = now || new Date();

    const {ids} = samplings;
    const current = minutesSinceMidnight(now);
    const currentSamplings = ids.map(id => samplings[id]).filter(({start, end}) => start <= now && end > now);
    const currentSamplingIDs = currentSamplings.map(({id}) => id);

    return ranges.filter(({start, end, samplingID, completed}) => (
        completed === false && currentSamplingIDs.includes(samplingID) && start <= current && end > current
    ));
};

const WEEK_DAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
/**
  * @params {Date} date - The date to get the weekday enum name from
  */
export const getWeekdayNumber = date => WEEK_DAYS[date.getDay()];



// WEBPACK FOOTER //
// ./scripts/utils/xps.js